import API from '../api/baseUrl'
import pathUrl from '../api/pathURL'
import {
  AdditionalDocumentsPayloadType,
  UpdateProfilePicturePayload,
  VehiclePayloadType,
} from '../types/interface'
import { getAuthToken } from './auth-token'

const getVehicleId = async () => {
  try {
    const token = await getAuthToken()
    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.get(pathUrl.getDriverProfile, options) // Get vehicle id
    return response.data.vehicle.vehicle_id
  } catch (error) {
    console.log(error)
    return error
  }
}

const addVehiclePhoto = async (payload: VehiclePayloadType) => {
  try {
    const token = await getAuthToken()
    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.post(
      pathUrl.postVehiclePhotos,
      { ...payload },
      options
    ) // Add vehicle photo
    const data = await response.data
    if (data) {
      return data.success
    }

    return null
  } catch (error) {
    console.log(error)
    return error
  }
}

const updateVehiclePhoto = async (payload: VehiclePayloadType) => {
  try {
    const token = await getAuthToken()

    const options = {
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.put(
      `${pathUrl.updateVehiclePhotos}${payload.vehicle_id}`,
      { ...payload },
      options
    )
    const data = await response.data
    if (data) {
      return data.success
    }
    return null
  } catch (error) {
    console.log(error)
    return error
  }
}

const addAdditionalDocuments = async (
  payload: AdditionalDocumentsPayloadType
) => {
  try {
    const token = await getAuthToken()

    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.post(
      pathUrl.additionalDocuments,
      { ...payload },
      options
    ) // Add additional documents
    const data = await response.data
    if (data) {
      return data.success
    }

    return null
  } catch (error) {
    console.log(error)
    return error
  }
}

const getDriverProvince = async (cityId: number) => {
  try {
    const response = await (
      await API.get(`${pathUrl.getCities}${cityId}`)
    ).data.province_id // Get driver province
    return response
  } catch (error) {
    console.error(error)
    return null
  }
}

const getDriverInfo = async () => {
  try {
    const token = await getAuthToken()

    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.get(pathUrl.getDriverProfile, options) // Get driver info
    const responseProvince = await getDriverProvince(response.data.city.id)

    return { ...response.data, province: responseProvince }
  } catch (error) {
    console.log(error)
    return error
  }
}

const updateDriverInfo = async (payload: UpdateProfilePicturePayload) => {
  try {
    const token = await getAuthToken()

    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.put(
      pathUrl.getDriverProfile,
      { ...payload },
      options
    ) // Update driver info
    // Portal API returns the raw updated profile on 2xx (no success flag) and throws on error;
    // return a 2xx boolean so a 502 (AF sync failed) is never shown as saved.
    return response.status >= 200 && response.status < 300
  } catch (error) {
    console.log(error)
    return false
  }
}

export {
  addAdditionalDocuments,
  addVehiclePhoto,
  getDriverInfo,
  getDriverProvince,
  getVehicleId,
  updateDriverInfo,
  updateVehiclePhoto,
}
